// extracted by mini-css-extract-plugin
module.exports = {"container":"top-app-bar_container__jK3WY","fix":"top-app-bar_fix__2VhT3","title":"top-app-bar_title__fxsbz"};